var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-clock-symbol"},[_c('div',{staticClass:"hand-little"}),_vm._v(" "),_c('div',{staticClass:"hand-big"})])}]

export { render, staticRenderFns }